export const GET_ALL_FLAT_COUNTER_FMC = "GET_ALL_FLAT_COUNTER_FMC"
export const CREATE_FLAT_COUNTER_FMC = "CREATE_FLAT_COUNTER_FMC"
export const CREATE_FLAT_COUNTER_FMC_LEGACY = "CREATE_FLAT_COUNTER_FMC_LEGACY"
export const UPDATE_FLAT_COUNTER_FMC = "UPDATE_FLAT_COUNTER_FMC"
export const UPDATE_FLAT_COUNTER_FMC_LEGACY = "UPDATE_FLAT_COUNTER_FMC_LEGACY"
export const DELETE_FLAT_COUNTER_FMC = "DELETE_FLAT_COUNTER_FMC"
export const DELETE_FLAT_COUNTER_FMC_LEGACY = "DELETE_FLAT_COUNTER_FMC_LEGACY"
